// import shortid from 'shortid'
import _ from 'lodash'
import store from '@/store'
import {
  categoryConfig,
  gameConfigCategoryResourceType,
  isCameraCategory,
  isFePresetCategory,
  isPresetOptionCategory,
  presetCategoryResourceType,
  is3DTextureCategory,
  is3DMaterialCategory,
  isPresetConfigParentCategory,
} from '@/store/creative/common/category'
import { isCocosModelAnimationCategory } from '@/views/creative/utils'

export const newTreeItem = (pid) => {
  return {
    pid: pid || 0,
    id: new Date().getTime(),
    name: '新建组',
    name_en: 'NewGroup',
    resource_type: 'group',
    sub_category: [],
  }
}

export const isLimitPlayItem = (item) => {
  return ![
    categoryConfig.globalClick.id,
    categoryConfig.ydClick.id,
    categoryConfig.autoClick.id,
    categoryConfig.autoEndTime.id,
    categoryConfig.elementStars.id,
    categoryConfig.gameConfigStars.id,
    categoryConfig.multiCustomCategory.id,
    categoryConfig.colorConfig.id,
  ].every((j) => j !== item.id)
}

export const isPresetCategory = (item) => {
  return item.resource_type === presetCategoryResourceType
}

export function isGroup(node) {
  // return node.resource_type === 'group'
  return (
    node.resource_type === 'group' ||
    isPresetOptionCategory(node) ||
    (node.resource_type === gameConfigCategoryResourceType &&
      node.sub_category &&
      node.sub_category.length)
  )
}

export function isGameConfigGroup(node) {
  return (
    node.resource_type === gameConfigCategoryResourceType &&
    node.sub_category &&
    node.sub_category.length
  )
}

export function getCategory() {
  return _.cloneDeep(store.creative.template.templateConfig.category).filter(
    (item) => item.sub_category && item.sub_category.length > 0,
  )
}

export const findById = (list, id) => {
  if (!_.isArray(id)) {
    id = [id]
  }
  const allNodes = getDescendants(list)
  const node = allNodes.filter((item) => id.indexOf(item.id) !== -1)
  if (node && node.length === 1) {
    return node[0]
  } else if (node && node.length > 1) {
    return node
  }
  return null
}

export function getDescendants(node) {
  const nodes = []

  if (!_.isArray(node)) {
    node = [node]
  }

  const rec = (tNode) => {
    nodes.push(tNode)

    if (tNode.sub_category && tNode.sub_category.length > 0) {
      _.each(tNode.sub_category, (item) => rec(item))
    }
  }
  _.each(node, (item) => rec(item))
  return nodes
}

// nodes el-tree节点
// target category节点
export function switchParent({ tree, nodes, target, index }) {
  if (!_.isArray(nodes)) {
    nodes = [nodes]
  }

  const move = (node, target, index) => {
    if (!target.sub_category) target.sub_category = []
    const cIndex = target.sub_category.findIndex((item) => item.id === node.id)
    // 移除被移动节点
    const parent = findById(tree, node.pid)
    parent.sub_category.splice(
      parent.sub_category.findIndex((item) => item.id === node.id),
      1,
    )
    if (cIndex !== -1 && index > cIndex) {
      // 移动节点在目标节点内部，目标节点大于排序
      target.sub_category.splice(index - 1, 0, node)
    } else {
      // 其他
      target.sub_category.splice(index, 0, node)
    }
    node.pid = target.id
  }
  nodes.forEach((node, i) => {
    move(node, target, index + i)
  })
}

// 获取根目录祖先节点
export function getRootNode({ tree, node }) {
  const getNotGroupNode = (node) => {
    const parent = findById(tree, node.pid)
    if (parent && isGroup(parent)) {
      return getNotGroupNode(parent)
    }
    return node
  }
  return getNotGroupNode(node)
}

export function unGroup({ tree, node, callback }) {
  const parent = findById(tree, node.pid)
  const index = parent.sub_category.findIndex((item) => item.id === node.id)
  if (callback) {
    callback(node.data.sub_category)
  } else {
    switchParent({
      tree,
      nodes: node.sub_category,
      target: parent,
      index,
    })
  }
  const cIndex = parent.sub_category.findIndex((item) => item.id === node.id)
  parent.sub_category.splice(cIndex, 1)
}

/**
 * 参数布局中隐藏的分类，当前限制的分类有，json、动画分类、镜头分类、材质分类\ 预设分类直接过滤了
 * @param category
 */
export function isHiddenCategory(category, isCommonTemplatePage) {
  return (
    category.resource_type === 'json' ||
    isCocosModelAnimationCategory(category) ||
    isFePresetCategory(category) ||
    isCameraCategory(category) ||
    is3DMaterialCategory(category) ||
    isPresetCategory(category) ||
    isPresetConfigParentCategory(category) ||
    (isCommonTemplatePage && is3DTextureCategory(category))
  )
}
